import {
  Box,
  Button,
  Card,
  FormControl,
  InputLabel,
  MenuItem,
  MenuList,
  Select,
} from "@mui/material";
import { DataGrid, GridLinkOperator, GridToolbarQuickFilter } from "@mui/x-data-grid";
import React, { useState } from "react";
import { useEffect } from "react";
import { useHistory, useParams } from "react-router";
import api from "../../../../components/services/api";
import Swal from "sweetalert2";
function QuickSearchToolbar() {
  return (
    <Box
      sx={{
        p: 2,
        width: '100%',
        display: 'flex',
        justifyContent: 'end'
      }}
    >

      <GridToolbarQuickFilter
        quickFilterParser={(searchInput) =>
          searchInput
            .split(',')
            .map((value) => value.trim())
            .filter((value) => value !== '')
        }
      />
    </Box>
  );
}
export default function SurveyTrain() {
  const [data, setdata] = useState([]);
  let { id } = useParams();
  const [selected, setSelected] = useState([]);
  const history = useHistory()


  const handlesun = () => {
    const body = {
      VoyNo: id,
      ContainerList: data


    }
    api.post(`/api/containermovement/inbound/update/survey`, body).then((res) => {
      if (res?.meta?.status == true) {
        Swal.fire(
          'อัพเดทสำเร็จ',
          'ส่งข้อมูลสำเร็จ',
          'success'
        )
      }
    })
  }
  const columns = [
    {
      field: "ContainerStockType",
      headerName: "STATUS",
      width: 150,
    },

    { field: "ContainerNo", headerName: "ContainerNo", width: 150 },
    // {
    //   field: "Size",
    //   headerName: "Size",
    //   width: 300,

    // },
    {
      field: "Booking",
      headerName: "Booking",
      width: 150,
    },
    {
      field: "Size",
      headerName: "Size",
      width: 100,
    },
    {
      field: "Grade",
      headerName: "Grade",
      width: 150,
      renderCell: (params) => {
        return (
          <>
            <FormControl sx={{ width: "100%" }} size="small">
              <InputLabel sx={{ top: "10px" }}>Grade</InputLabel>
              <Select
                label="Grade"
                style={{
                  width: "50%",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
                value={params?.row?.Grade || ''}
                onChange={(e) => {
                  const select = data?.map((y) => {
                    y.Grade =
                      y?.ContainerNo === params?.row?.ContainerNo
                        ? e.target.value
                        : selected.filter(
                          (x) => x.ContainerNo === y?.ContainerNo
                        ).length > 0
                          ? e.target.value
                          : y?.Grade;
                    return y;
                  });

                  setdata([...select]);
                }}
                InputLabelProps={{ shrink: true }}
              >
                <MenuItem value="A">A</MenuItem>
                <MenuItem value="B">B</MenuItem>
                <MenuItem value="C">C</MenuItem>
                <MenuItem value="D">D</MenuItem>
              </Select>
            </FormControl>
          </>
        );
      },
    },
    {
      field: "Seal",
      headerName: "Survey Status",
      width: 150,
      renderCell: (params) => {
        return (
          <>
            <FormControl sx={{ width: "100%" }} size="small">
              <InputLabel sx={{ top: "10px" }}>Survey Status</InputLabel>
              <Select
                label="Survey Status"
                style={{
                  width: "80%",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
                disabled={params?.row?.RepairStatus === 'Processing' ? true : params?.row?.RepairStatus === 'Done' ? true : false}
                value={params?.row?.SurveyStatus || ''}
                onChange={(e) => {
                  const select = data?.map((y) => {
                    y.SurveyStatus =
                      y?.ContainerNo === params?.row?.ContainerNo
                        ? e.target.value
                        : selected.filter(
                          (x) => x.ContainerNo === y?.ContainerNo
                        ).length > 0
                          ? e.target.value
                          : y?.SurveyStatus;
                    return y;
                  });

                  setdata([...select]);
                }}
              >
                <MenuItem value='Complete'>Complete</MenuItem>
                <MenuItem value='Damage'>Damage</MenuItem>
              </Select>
            </FormControl>
          </>
        );
      },
    },
    {
      field: "JobOrderNo",
      headerName: "Job Order No",
      width: 150,
    },
    {
      field: "",
      headerName: "Repair Status",
      width: 150,
      renderCell: (params) => {
        return (
          <>
            <FormControl sx={{ width: "100%" }} size="small">
              <InputLabel sx={{ top: "10px" }}>Repair Status</InputLabel>
              <Select
                label="Repair Status"
                style={{
                  width: "80%",
                  marginTop: "10px",
                  marginBottom: "10px",
                }}
                disabled
                value={params?.row?.RepairStatus || ''}
                onChange={(e) => {
                  const select = data?.map((y) => {
                    y.RepairStatus =
                      y?.ContainerNo === params?.row?.ContainerNo
                        ? e.target.value
                        : selected.filter(
                          (x) => x.ContainerNo === y?.ContainerNo
                        ).length > 0
                          ? e.target.value
                          : y?.RepairStatus;
                    return y;
                  });

                  setdata([...select]);
                }}
              >
                <MenuItem value='New'>New</MenuItem>
                <MenuItem value='Processing'>Processing</MenuItem>
                <MenuItem value='Done'>Done</MenuItem>
              </Select>
            </FormControl>
          </>
        );
      },
    },
  ];
  const getdata = async () => {
    try {
      const data = await api.get(`api/containermovement/inbound/detail/${id}`);
      const res = data?.data;
      setdata(res?.Container);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getdata();
  }, [id]);

  return (
    <>
      <Box
        sx={{
          height: 650,
          width: "100%",
        }}
      >
        <DataGrid
          getRowId={(r) => r.ContainerNo}
          rows={data}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10]}
          hideFooterSelectedRowCount
          disableColumnFilter
          disableColumnMenu
          disableColumnSelector
          disableSelectionOnClick
          checkboxSelection
          onSelectionModelChange={(ids) => {
            const selectedIDs = new Set(ids);
            const selectedRows = data?.filter((row) =>
              selectedIDs.has(row.ContainerNo)
            );
            setSelected(selectedRows);
          }}
          initialState={{
            filter: {
              filterModel: {
                items: [],
                quickFilterLogicOperator: GridLinkOperator.Or,
              },
            },
          }}
          components={{ Toolbar: QuickSearchToolbar }}
        />
      </Box>
      <Box sx={{ display: "flex", marginTop: "25px" }}>
        <Button
          sx={{ width: 80 }}
          type="button"
          variant="outlined"
          style={{
            color: "#80c340",
            borderColor: "#80c340",
            marginRight: "10px",
          }}
          onClick={history.goBack}
        >
          close
        </Button>
        <Button
          sx={{ width: 80 }}

          variant="contained"
          style={{
            background: "#80c340",
            borderColor: "#80c340",
            marginRight: "10px",
          }}
          onClick={handlesun}
        >
          Save
        </Button>
      </Box>
    </>
  );
}
